import { useTranslation } from 'react-i18next'
import ReverCard from '@/ui/components/rever-card'
import { useAppSelector } from '@/redux/hooks'
import { PortalFooter } from '@/ui/layout/portal-footer'
import { ShieldCheckIcon } from '@/ui/icons/shield-check'

export const CoverCancellationSuccessPage = () => {
  const { t } = useTranslation()

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  return (
    <div className="relative flex min-h-screen flex-col bg-white lg:bg-[#f2f2f2]">
      <header className="sticky top-0 z-10 flex min-h-16 w-full items-start justify-center gap-4 border-b border-solid border-neutral-200 bg-white px-4 py-6">
        {settings.branding?.logo_url ? (
          <div className="h-8 max-w-36">
            <img
              src={settings.branding.logo_url}
              height={32}
              width={144}
              alt={settings.branding.title}
              className="h-full w-auto object-contain"
            />
          </div>
        ) : null}
      </header>
      <div className="flex h-full flex-col items-center justify-center">
        <ReverCard className="lg:!p-8">
          <div className="space-y-8">
            <div className="flex flex-col items-center gap-4 text-center">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-success-light text-success-dark">
                <ShieldCheckIcon width={28} height={28} />
              </span>
              <h1 className="max-w-md text-2xl font-semibold leading-tight [text-wrap:balance]">
                {t('cover_cancellation.success_title')}
              </h1>
              <p className="text-sm leading-relaxed text-neutral-800 [text-wrap:pretty]">
                {t('cover_cancellation.success_description')}
              </p>
            </div>
          </div>
        </ReverCard>
      </div>
      <div className="mt-auto flex items-center p-4 lg:bg-[#F2F2F2]">
        <PortalFooter />
      </div>
    </div>
  )
}
